import type { RequestFn } from '../http';
import type { KianUsage } from '../types/core';

/**
 * Vor-Ort-Chancen: offene Tickets des Kunden, von KIAN danach eingestuft, ob sie
 * sich beim anstehenden Vor-Ort-Termin gleich mit erledigen lassen.
 */

export type OnsiteVerdict = 'ONSITE' | 'MAYBE' | 'REMOTE';

export interface OnsiteOpportunity {
  ticketId: string;
  ticketNumber: string | null;
  subject: string;
  status: string | null;
  priority: string | null;
  createdDate: string | null;
  ageDays: number | null;
  /** null = noch nicht bewertet (z. B. KI-Fehler) — Ticket wird trotzdem gelistet */
  verdict: OnsiteVerdict | null;
  reason: string | null;
  bringHint: string | null;
  assessedAt: string | null;
}

export interface OnsiteOpportunitiesResult {
  opportunities: OnsiteOpportunity[];
  assessedNow: number;
  aiError: string | null;
  /** Modell, Tokens, Kosten — nur wenn KIAN in dieser Abfrage neu eingestuft hat */
  kianUsage?: KianUsage;
}

/** Wie ein mitbearbeitetes Ticket abgeschlossen wird. */
export type TicketDisposition = 'PLANNED' | 'RESOLVED' | 'IN_PROGRESS' | 'UNCHANGED';

/**
 * Ein weiteres beim selben Termin bearbeitetes Ticket, wie es am Servicebericht
 * hängt. Beim Finalisieren bekommt jedes davon Kommentar, Beleg und Statuswechsel.
 */
export interface AdditionalTicketRef {
  weclappTicketId: string;
  // null statt undefined: So kommen die Felder aus der Datenbank zurück.
  ticketNumber?: string | null;
  subject?: string | null;
  disposition?: TicketDisposition;
  /** Eigener Kommentartext; leer = Standard-Verweis auf den Servicebericht */
  comment?: string | null;
  internal?: boolean;
  attachReport?: boolean;
  /** Nur lesend vom Server: gesetzt, sobald der Kommentar in weclapp steht */
  commentPostedAt?: string | null;
  lastError?: string | null;
}

export function createOnsiteOpportunitiesApi(request: RequestFn) {
  return {
    async getOnsiteOpportunities(weclappCustomerId: string, excludeTicketId?: string) {
      const params = new URLSearchParams({ weclappCustomerId });
      if (excludeTicketId) params.set('excludeTicketId', excludeTicketId);
      return request<OnsiteOpportunitiesResult>(
        `/service-report/onsite-opportunities?${params.toString()}`
      );
    },
  };
}
